import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'
import { styled } from 'styled-components'

import { Banner, Button, FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { useLogError } from '@/helpers/useLogError'

const FallbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const Fallback = ({ resetErrorBoundary }: FallbackProps) => (
  <FallbackWrapper role="alert">
    <Banner
      type="error"
      title={
        <FormattedMessage id="Auction.details.actionColumn.errorBoundary.title" />
      }
    >
      <FormattedMessage id="Auction.details.actionColumn.errorBoundary.message" />
    </Banner>
    <Button onClick={resetErrorBoundary}>
      <FormattedMessage id="Auction.details.actionColumn.errorBoundary.tryAgain" />
    </Button>
  </FallbackWrapper>
)

export const AuctionActionColumnErrorBoundary = ({
  listingId,
  children,
}: {
  listingId: string
  children: ReactNode
}) => {
  const logErrorContext = useMemo(
    () => ({ listingId, boundary: 'AuctionActionColumn' as const }),
    [listingId]
  )
  const logError = useLogError(logErrorContext)

  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={logError}>
      {children}
    </ErrorBoundary>
  )
}
